import Confetti from 'react-confetti'
import { ClientOnly } from 'remix-utils/client-only'

export function ConfettiComponent({ id }: { id?: string | null }) {
	if (!id) return null

	return (
		<ClientOnly>
			{() => (
				<Confetti
					key={id}
					run={Boolean(id)}
					recycle={false}
					numberOfPieces={500}
					width={window.innerWidth}
					height={window.innerHeight}
					gravity={0.3}
				/>
			)}
		</ClientOnly>
	)
}
